import { axios } from '@Root/API'

export const getAll = (courseSessionId, params) => {
	return axios.get(`get/reference-period-student-load/student-course-session/${courseSessionId}`, { params })
}
